import PropTypes from 'prop-types'
import qs from 'query-string'

import { BookingType } from 'loads/domain/LoadOffer'

import { EXPECTED_QUERY_PARAMS } from './routingConfig'
import { SUPPORTED_STEPS } from './stepsConfig'

function getPath(
  pathname,
  search,
  loadId,
  step = SUPPORTED_STEPS.CONFIRMATION,
  bookingType = BookingType.BookNow
) {
  if (!loadId) {
    return `${pathname}?${search}`
  }

  const query = qs.parse(search)

  return `${pathname}?${qs.stringify({
    ...query,
    [EXPECTED_QUERY_PARAMS.BOOKING_OFFER_ID]: loadId,
    [EXPECTED_QUERY_PARAMS.BOOKING_STEP]: step,
    [EXPECTED_QUERY_PARAMS.BOOKING_TYPE]: bookingType,
  })}`
}

function BookLink({ children }) {
  return children
}

BookLink.propTypes = {
  loadId: PropTypes.string.isRequired,
  bookingType: PropTypes.oneOf(Object.values(BookingType)),
  children: PropTypes.node.isRequired,
}

BookLink.defaultProps = {
  step: SUPPORTED_STEPS.CONFIRMATION,
  bookingType: BookingType.BookNow,
}

BookLink.getPath = getPath

export { BookLink }
